<div>
  <h1>Chats</h1>
</div>

<app-chats-list></app-chats-list>
